/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import ProductsTable from "../../components/CommonComponents/ProductsTable";
import { fetchProducts } from "../../store/reducers/createProfile";
import { fetchDeleteProduct } from "../../store/reducers/createProfile/apithunk";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../rollbarConfig";
import { ROUTE_PATH } from "../../constants/route";
import inventorySetupStyles from "./InventorySetup.styles";
import ProductDeleteModal from "./ProductDeleteModal";

const InventorySetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = inventorySetupStyles(theme);
  const [products, setProducts] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [count, setCount] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState(null);

  const myId = useSelector((state) => state?.createProfile?.userProfile?.id);
  
  const getAllProducts = async () => {
    setLoading(true);
    const querry = `?search=${searchQuery}&category=All&page_no=${count}&page_size=${pageSize}&seller=${myId}`;
    try {
      const res = await dispatch(fetchProducts(querry));
      const { data, status, _meta } = res.payload;
      if (status) {
        setProducts(data);
        setPaginationData(_meta);
      }
    } catch (error) {
      console.error("Products fetch failed:", error);
      rollbar.error("Error message", error);      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getAllProducts();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, count, pageSize]);

  const DeleteProduct = async (id) => {
    try {
      const res = await dispatch(fetchDeleteProduct(id));
      const { status, message } = res?.payload;
      if (status) {
        ToastNotifySuccess(message);
        setShowDeleteModal(false);
        setDeleteProductId(null);
        getAllProducts();
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Delete product failed:", error);
      rollbar.error("Error message", error);
    }
  };

  const handleAddProduct = () => {
    navigate(ROUTE_PATH.ADD_INVENTORY_PRODUCT_NEW);
  };

  const handleEditProduct = (id) => {
    navigate(`${ROUTE_PATH.EDIT_INVENTORY_PRODUCT.replace(':id', id)}`);
  };

  const handleViewDetails = (id) => {
    navigate(`${ROUTE_PATH.DETAILS_INVENTORY_PRODUCT.replace(':id', id)}`);
  };

  return (
    <Box sx={styles.container}>
      <Box>
        <Box sx={styles.headSection}>
          <Box sx={styles.searchBar}>
            <TextField
              variant='outlined'
              placeholder='Search by product name'
              sx={styles.searchBox}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Button
            variant='contained'
            color='primary'
            sx={styles.addBtn}
            onClick={handleAddProduct}
          >
            Add new product
          </Button>
        </Box>
        <Box sx={styles.mobileBtns}>
          <Typography>{paginationData?.total_count} Products</Typography>
          <Button
            variant='contained'
            color='primary'
            sx={styles.mobileAddBtn}
            onClick={handleAddProduct}
          >
            Add new product
          </Button>
        </Box>
        <Box sx={styles.tableContainer}>
          <ProductsTable
            data={products}
            paginationData={paginationData}
            loading={loading}
            setPageSize={setPageSize}
            count={count}
            pageSize={pageSize}
            setCount={setCount}
            onEdit={handleEditProduct}
            onDelete={(id) => {
              setShowDeleteModal(true);
              setDeleteProductId(id);
            }}
            onDetails={handleViewDetails}
          />
        </Box>
      </Box>
      <ProductDeleteModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setDeleteProductId(null);
        }}
        onConfirm={DeleteProduct}
        productId={deleteProductId}
      />
    </Box>
  );
};

export default InventorySetup;

